export default (props, context) => {
	const {
		MentorCard = [],
		heading = "",
		subHeading = "",
		wrapper = [],
	} = props;

	// Wrapper refers to the new Storyblok component of reusable mentor profiles
	// The below return statement provides backward compatibility
	if (!!!wrapper.length || !!!wrapper[0].selectedCourses.value?.length) {
		// wrapper is the new component for ReusableMentorProfiles.
		// If wrapper is empty, or if it was initialized (in Storyblok) but no courses were selected, we render the old component
		return {
			heading,
			subHeading,
			list: getMentors(MentorCard),
			wrapperEmpty: true,
			wrapper,
		};
		// Returned when wrapper is empty- applies to both PREVIEW and STATIC_SITE
	}

	if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
		return {
			heading,
			subHeading,
			list: MentorCard,
			wrapperEmpty: false,
			wrapper,
		};
		// Returned for PREVIEW
	}

	const graphQlMentorList = context?.mentorProfilesData || [];

	return {
		heading,
		subHeading,
		list: buildMentorProfiles(wrapper, MentorCard, graphQlMentorList),
		wrapperEmpty: false,
		wrapper,
	};
	// Returned for STATIC_SITE
};

export const buildMentorProfiles = (
	wrapper,
	MentorCard = [],
	mentorList = [],
) => {
	var selectedCourses = wrapper[0].selectedCourses.value;
	var mentorCount = wrapper[0].mentorCount;

	// Filtering courses selected on storyblok among all datasource entries
	const selectedDatasourceEntries = selectedCourses.map((selectedId) =>
		mentorList.find((element) => element.id == selectedId),
	);
	var filteredDatasourceEntries = selectedDatasourceEntries.filter(
		(element) => !!element,
	);

	// The value part of datasource entries is stringified JSON that should be parsed back
	filteredDatasourceEntries.forEach((course) => {
		try {
			course.value = JSON.parse(course.value).data;
		} catch (err) {
			console.log("couldn't parse JSON");
			console.error(err);
		}
	});

	// In case the mentorCount we get from storyblok is greater than the number of available mentors
	// in selected courses, we'll reduce the count we display
	let sum = 0;
	filteredDatasourceEntries.forEach((ele) => {
		// arr contains the list of mentors in a particular course
		const arr = ele.value;
		sum += arr.length;
	});
	if (mentorCount > sum) mentorCount = sum;

	var list = []; // Stores the final mentor-list to display
	var nthMentorOfCourse = 0; // Index variable
	var flag = false; // set to true when we've pushed the required number of mentors into the list

	// Example of what's happening here-
	// We have 4 mentors from 3 selected courses (say, A, B, C are the courses and A has mentors 1A, 2A, 3A...)
	// Then, the mentor list will be [ 1A - 1B - 1C - 2A ] (ordered in a cyclic fashion)
	while (true) {
		for (
			let courseNo = 0;
			courseNo < filteredDatasourceEntries.length;
			courseNo++
		) {
			const mentorsOfParticularCourse =
				filteredDatasourceEntries[courseNo].value;
			if (mentorsOfParticularCourse.length > nthMentorOfCourse) {
				list.push(mentorsOfParticularCourse[nthMentorOfCourse]);
			}
			if (list.length >= mentorCount) {
				flag = true;
				break;
			}
		}
		if (flag) break;
		nthMentorOfCourse++;
	}

	return getMentors(formatList(list));
};

// Adds bootstrap classes for styling
const getMentors = (mentors = []) => {
	return mentors.map(({ gridClass = {}, ...mentor }) => {
		let bootStrapClass = "";
		const tags = gridClass.tags;
		if (tags && tags.length) {
			tags.forEach(({ text }) => {
				bootStrapClass = `${bootStrapClass} ${text}`;
			});
		}
		return {
			...mentor,
			gridClass:
				bootStrapClass || "col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3",
		};
	});
};

// This function bridges some gaps between how we store mentor data on the datasource and how we should pass them to the Mentor Card element
const formatList = (list = []) => {
	return list.map((ele) => ({
		...ele,
		avatar: {
			altTag: ele?.avatarAltText || "mentorAvatar",
			image: ele.avatar,
			plugin: "image-field",
		},
		companyLogo: {
			altTag: ele?.logoAltText || "companyLogo",
			image: ele.company,
			plugin: "image-field",
		},
		component: "MentorCard",
	}));
};
